/** 轮播最外层节点控制脚本 */
/** 轮播风格预设类型 */
export enum CarouselType {
  NormalCarousel, // 常规轮播
  PulseScaleCarousel, // 原地缩放轮播===
  RollScaleCarousel, // 滚动缩放轮播
  OpacityCarousel, // 透明度轮播
  OpacityScaleCarousel, // 渐隐缩放轮播
}
export enum Direction {
  vertical = 'vertical',
  horizontal = 'horizontal',
}

export enum PlayMod {
  auto = 'auto',
  manual = 'manual',
}

export enum TriggerManual {
  click = 'click',
  drag = 'drag',
}
